import { fetchResourcePrices, FetchResourcePricingParams } from 'api/resource/fetchResourcePrices';
import { useQuery } from 'react-query';
import { queryKeys } from 'utils/react-query';

type Params = {
  keepPreviousData?: boolean;
} & FetchResourcePricingParams;

/**
 * Currently it can be used to fetch resource pricing for multiple models.
 */
export function useResourcePricing({ keepPreviousData, models }: Params) {
  const hasValidModels = Array.isArray(models) && models.length > 0;
  const isResourcePricingEnabled = hasValidModels && areModelsValid(models);
  const modelsToFetch = hasValidModels ? convertModelsToPartialModelInfo(models) : [];

  const { data } = useQuery({
    enabled: Boolean(isResourcePricingEnabled),
    queryKey: [queryKeys.resourcePricing, { models: modelsToFetch }],
    queryFn: () => fetchResourcePrices({ models: modelsToFetch }),
    select: (response) => response?.model_prices,
    keepPreviousData,
  });

  return data || [];
}

function convertModelsToPartialModelInfo(models: Params['models']) {
  return models.map((model) => ({
    id: model?.id,
    user_id: model?.user_id,
    app_id: model?.app_id,
  }));
}

function areModelsValid(models: Params['models']) {
  if (!Array.isArray(models) || models.length === 0) {
    return false;
  }

  return models
    .map((model) => {
      const isValidModel = model && typeof model === 'object' && !!model.id && !!model.user_id && !!model.app_id;
      return isValidModel;
    })
    .every(Boolean);
}
